var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArquiveSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 164.016,
    height: 164.016,
    viewBox: "0 0 164.016 164.016",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1",
    "data-name": "Grupo 1",
    transform: "translate(-83.91 -199.473)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_10",
    "data-name": "Ret\\xE2ngulo 10",
    width: 115.977,
    height: 115.977,
    rx: 9,
    transform: "translate(165.918 199.473) rotate(45)",
    fill: "#9cf4c8",
    opacity: 0.387
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_11",
    "data-name": "Ret\\xE2ngulo 11",
    width: 60,
    height: 43,
    transform: "translate(135.825 262)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "noun-check-4821822",
    d: "M150.671,17.366a10.987,10.987,0,0,0-15.523,0L87.376,65.141a10.993,10.993,0,0,0,0,15.523l47.775,47.775a10.989,10.989,0,0,0,15.522,0l47.775-47.775a10.993,10.993,0,0,0,0-15.523Zm16.753,44.792L140.467,89.115a3.864,3.864,0,0,1-5.467,0L118.4,72.51a3.867,3.867,0,1,1,5.468-5.468l13.867,13.871L161.957,56.69a3.866,3.866,0,1,1,5.467,5.468Z",
    transform: "translate(22.608 208.579)",
    fill: "#56db98"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArquiveSuccessIcon);
export default __webpack_public_path__ + "static/media/arquive_success_icon.9d911f0a09716ba4837d228182a01e70.svg";
export { ForwardRef as ReactComponent };